import { Component, OnInit, ViewChild } from '@angular/core';
import { faBroom, faCircle, faCouch, faFile, faFileSignature, faHouseUser, faToolbox, faWater } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-become-owner',
    templateUrl: './catalogue.component.html',
    styleUrls: ['./catalogue.component.scss']
  })

  
export class CatalogueComponent implements OnInit {

  public faFile = faFile;
  public faToolBox = faToolbox;
  public faCircle = faCircle;
  public faCouch = faCouch;
  public faBroom = faBroom;
  public faWater = faWater;
  public faDocSign = faFileSignature;
  public faHouseUser = faHouseUser;

  constructor(){
    
  }

  ngOnInit(){
      window.scroll(0,0);
  }
}